export default {
  'meta': {
    'langName': 'GERMAN',
    'lang': 'Deutsch'
  },
  'title': 'PRODUKTRÜCKRUF BASKETBALLKORB B900 BOX NBA TARMAK',
  'description': 'Wir haben festgestellt, dass der Pfosten unseres Basketballkorbs B900 beim Bewegen ohne Kurbel senkrecht herunterfallen kann.\nZur Sicherheit solltest du den Korb ab sofort nicht mehr benutzen, wenn die Kurbel zur Höheneinstellung nicht angebracht ist.\nMit einem Reparaturset, dass wir dir kostenlos schicken, und das einfach anzuwenden ist, kannst du dein Produkt wieder sicher machen.\nDie Website zu diesem Rückruf ist gerade in Arbeit. Dort ist genau beschrieben, was zu tun ist.\nWir sagen dir Bescheid, sobald sie verfügbar ist (im Laufe des Monats).',
  'status': 'Translation validated by COUNTRY',
  'https://decathlonrecallb900box': {
    'fandi': {
      'fr/': 'Austria\nGermany'
    }
  }
} as const
